module.exports = __webpack_public_path__ + "img/itFinMagaz.77462273.png";